import React from "react";
import { connect } from "react-redux";
import { withRouter } from "react-router-dom";
import { makeStyles } from "@material-ui/core/styles";
import { getFacility } from "../../store/actions";
import Button from "../../../ui/Button";
import Progress from "../../../ui/Progress";
import MapComponent from "../Map";
import InfoDrawer from "../../../ui/InfoDrawer";
import ImageBox from "../../../ui/InfoDrawer/components/ImageBox";
import TitleField from "../../../ui/InfoDrawer/components/TitleField";
import DeviderLine from "../../../ui/InfoDrawer/components/DeviderLine";
import InfoField from "../../../ui/InfoDrawer/components/InfoField";

const useStyles = makeStyles(theme => ({
  map: {
    marginTop: 16
  },
  more: {
    marginTop: 24,
    marginBottom: 80,
    display: "flex",
    justifyContent: "center"
  },
  progress: {
    display: "flex",
    justifyContent: "center"
  }
}));

const FacilityInfoDrawer = ({
  open,
  getFacility,
  facilityId,
  facilityCard,
  history,
  hideLink,
  handleDrawerClose
}) => {
  const classes = useStyles();
  const [card, setCard] = React.useState(null);

  React.useEffect(() => {
    if (facilityId !== -1) {
      setCard(null);
      getFacility(facilityId);
    }
  }, [facilityId]);

  React.useEffect(() => {
    setCard(facilityCard);
  }, [facilityCard]);

  const onLinkClick = () => {
    history.push(`/work/app/facilities/${card.id}`);
  };

  return (
    <InfoDrawer open={open}>
      {card ? (<>
          <ImageBox image={(card.photos && card.photos.length) > 0 ? card.photos[0].fileId : null}/>
          <TitleField title={card.name}/>
          <TitleField title={card.orgName}/>
          <DeviderLine/>
          <InfoField name="Назначение" value={card.assign || '-'} display={"block"}/>
          <InfoField name="Адрес" value={card.address || '-'} display={"block"}/>
          {(card.latitude && card.longitude) &&
          <div className={classes.map}>
            <MapComponent
              width={240}
              height={150}
              center={[card.latitude, card.longitude]}
              readOnly
            />
          </div>}
          <DeviderLine/>
          <div className={classes.more}>
            {!hideLink && <Button onClick={onLinkClick}>Подробнее</Button>}
          </div>
        </>) : (
        <div className={classes.progress}>
          <Progress />
        </div>
      )}
    </InfoDrawer>
  );
};

const mapStateToProps = state => ({
  facilityCard: state.facilities.facilityCard
});

const mapDispatchToProps = dispatch => ({
  getFacility: id => dispatch(getFacility(id))
});

export default connect(
  mapStateToProps,
  mapDispatchToProps
)(withRouter(FacilityInfoDrawer));
